<template>
  <div class="nav-header">
    <div class="nav-navbar flex-box">
      <div class="left">
        <el-image class="title-img" :src="imgsrc" fit="contain"></el-image>
        <div class="title">
          空气质量评估平台
          <div>北京大学陈松蹊研究团队</div>
        </div>
      </div>

      <div class="right flex-box">
        <div
          v-for="(item, i) in navList"
          :key="i"
          :index="item.name"
          class="single-nav"
        >
          <router-link :to="item.name">{{ item.navItem }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-header {
  background-color: #8c0000;
}

/* 最上面的 title部分 */
.flex-box {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  max-width: 1200px;
  margin: 0 auto;
}

/* navbar 部分 */
.nav-navbar {
  max-width: 1080px;
  padding: 10px 20px;
}

.nav-navbar .left {
  height: 50px;
  display: flex;
  align-items: center;
  text-align: left;
}
.nav-navbar .title-img {
  width: 40px;
}
.nav-navbar .left .title {
  margin: 0;
  color: #e2e2e2;
  display: inline-block;
  /* line-height: 40px; */
  font-weight: 900;
  font-size: 24px;
  margin-left: 15px;
}

.left .title div {
  font-size: 10px;
  font-weight: 400;
  /* height: 12px; */
  text-align-last: justify;
  text-align: justify;
  text-justify: distribute-all-lines;
}
.single-nav {
  align-self: center;
  vertical-align: center;
  /* margin-right: 20px; */

  margin: auto;
  border-bottom: 1px solid transparent;
}
.single-nav a {
  display: inline-block;
  padding: 10px 20px;
  text-decoration: none;
  color: #e2e2e2;
  /* font-size: 18px; */
}
.single-nav:hover {
  border-bottom: 1px solid rgba(255, 187, 0, 0.842);
}
.single-nav:hover a {
  /* background: rgba(0, 0, 0, 0.2); */
  color: rgba(255, 187, 0, 0.842);
}
</style>

<script>
export default {
  name: "HeaderNavbar",
  data() {
    return {
      fit: "contain",
      props: { multiple: true, expandTrigger: "hover" },
      options: [],
      cities: [],
      imgsrc: require("@/assets/pkulogo.png"),
      assesscity: "",

      navList: [
        { name: "/", navItem: "首页" },
        // { name: "/assessintro", navItem: "评估方法与内容" },
        { name: "/results", navItem: "评估结果及介绍" },
        { name: "/reports", navItem: "评估报告" },
        { name: "/data", navItem: "数据质量" },
        { name: "/contact", navItem: "联系我们" },
      ],
    };
  },
  computed: {
    de_active: function () {
      if (
        this.$router.history.current.path == "/city" ||
        this.$router.history.current.path == "/area"
      ) {
        return "/search";
      } else {
        return this.$router.history.current.path;
      }
    },
  },
  props: {},
  methods: {
    addCityEn() {
      this.assesscity.forEach((element) => {
        this.cities.forEach((prov) => {
          if (prov[1] == element[1]) {
            element.push(prov[2]);
          }
        });
      });
    },
    gotoAssess() {
      this.addCityEn();
      if (this.assesscity.length > 1) {
        this.$router.push({
          path: "/area",
          query: { cityname: JSON.stringify(this.assesscity) },
        });
        this.assesscity = [];
        loading.close();
      } else if (this.assesscity.length == 1) {
        this.$router.push({
          path: "/city",
          query: { cityname: JSON.stringify(this.assesscity) },
        });
        this.assesscity = [];
        loading.close();
      } else {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: "请选择查询的城市",
        });
      }
    },
  },
  created() {
    const that = this;
    // 获取城市
    this.$axios
      // .post("/AQAssess/getData.php", {
      //   database: "cities",
      // })

      .get("/AQAssess/getcities")
      .then((res) => {
        that.cities = res.data;
        let options = [];
        that.cities.forEach((element) => {
          let add = false;
          for (let i = 0; i < options.length; i++) {
            if (options[i].value == element[0]) {
              options[i].children.push({
                value: element[1],
                label: element[1],
              });

              add = true;
              break;
            }
          }
          if (!add) {
            options.push({
              value: element[0],
              label: element[0],
              children: [{ value: element[1], label: element[1] }],
            });
          }
        });

        that.options = options;
      })
      .catch((e) => {
        this.$message({
          type: "info",
          message: "获取城市数据失败",
        });
      });
  },
  mounted() {},
  watch: {},
};
</script>
